import { GET_CLIENT_BANK_DETAILS, GET_CLIENT_BANK_DETAILS_ERROR, GET_CLIENT_CALCULATE_INVOICE_PAYMENT, GET_CLIENT_CALCULATE_INVOICE_PAYMENT_ERROR, GET_CLIENT_CURRENCY_LIST, GET_CLIENT_CURRENCY_LIST_ERROR, GET_CLIENT_INVOICE_BY_REFNUM, GET_CLIENT_INVOICE_BY_REFNUM_ERROR, GET_CLIENT_INVOICE_LIST, GET_CLIENT_INVOICE_LIST_ERROR, GET_CLIENT_INVOICE_PAYMENT, GET_CLIENT_INVOICE_PAYMENT_ERROR, GET_CLIENT_INVOICE_STATUS_LIST, GET_CLIENT_INVOICE_STATUS_LIST_ERROR, RESET_CLIENT_INVOICE_DETAILS, RESET_CLIENT_INVOICE_PAYMENT_DETAILS, SAVE_CLIENT_INVOICE_PAYMENTS, SAVE_CLIENT_INVOICE_PAYMENTS_ERROR } from "../../actions/types"

const initialState = {
    invoiceObject: {},
    invoiceListObject: [],
    invoiceStatusList: [],

    invoicePaymentCalculation: {},
    invoicePayment: {},
    invoiceCurrencyList: [],
    paymentInvoice: {},

    savedInvoicePayment: 0,
    clientBankDetails: {},
}

export const clientInvoice = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLIENT_INVOICE_BY_REFNUM: {
            return {
                ...state,
                invoiceObject: action.payload.data
            }
        }
        case GET_CLIENT_INVOICE_BY_REFNUM_ERROR: {
            return {
                ...state,
                invoiceObject: {},
            }
        }

        case GET_CLIENT_INVOICE_LIST: {
            return {
                ...state,
                invoiceListObject: action.payload.data
            }
        }

        case GET_CLIENT_INVOICE_LIST_ERROR: {
            return {
                ...state,
                invoiceListObject: {}
            }
        }

        case GET_CLIENT_INVOICE_STATUS_LIST: {
            return {
                ...state,
                invoiceStatusList: action.payload.data
            }
        }

        case GET_CLIENT_INVOICE_STATUS_LIST_ERROR: {
            return {
                ...state,
                invoiceStatusList: []
            }
        }

        case GET_CLIENT_CALCULATE_INVOICE_PAYMENT: {
            return {
                ...state,
                invoicePaymentCalculation: action.payload.data
            }
        }
        case GET_CLIENT_CALCULATE_INVOICE_PAYMENT_ERROR: {
            return {
                ...state,
                invoicePaymentCalculation: {}
            }
        }
        case GET_CLIENT_INVOICE_BY_REFNUM: {
            return {
                ...state,
                invoicePayment: action.payload.data
            }
        }
        case GET_CLIENT_INVOICE_BY_REFNUM_ERROR: {
            return {
                ...state,
                invoicePayment: {}
            }
        }

        case GET_CLIENT_CURRENCY_LIST: {
            return {
                ...state,
                invoiceCurrencyList: action.payload.currencyList
            }
        }
        case GET_CLIENT_CURRENCY_LIST_ERROR: {
            return {
                ...state,
                invoiceCurrencyList: []
            }
        }

        case GET_CLIENT_INVOICE_PAYMENT: {
            return {
                ...state,
                paymentInvoice: action.payload.data
            }
        }
        case GET_CLIENT_INVOICE_PAYMENT_ERROR: {
            return {
                ...state,
                paymentInvoice: {}
            }
        }

        case SAVE_CLIENT_INVOICE_PAYMENTS: {
            return {
                ...state,
                savedInvoicePayment: action.payload.data
            }
        }
        case SAVE_CLIENT_INVOICE_PAYMENTS_ERROR: {
            return {
                ...state,
                savedInvoicePayment: 0
            }
        }

        case RESET_CLIENT_INVOICE_PAYMENT_DETAILS: {
            return {
                ...state,
                invoicePaymentCalculation: {},
                invoiceCurrencyList: [],
                paymentInvoice: {},
            }
        }

        case RESET_CLIENT_INVOICE_DETAILS: {
            return {
                ...state,
                invoiceObject: {},
            }
        }

        case GET_CLIENT_BANK_DETAILS: {
            return {
                ...state,
                clientBankDetails: action.payload.data
            }
        }

        case GET_CLIENT_BANK_DETAILS_ERROR: {
            return {
                ...state,
                clientBankDetails: {}
            }
        }

        default: {
            return {
                ...state
            }
        }
    }
}